export default __webpack_public_path__ + "static/media/logo.d656ff68.png";